import type { ReactNode } from 'react';
import { Link, Outlet } from 'react-router';
import { usePageAnnouncements } from '../route-meta';

/**
 * Error / maintenance / logout pages: no session required, no data fetching, so they render even
 * when the API is down. Same look as the static nginx pages (public/50x.html, maintenance.html).
 */
export function StatusLayout({ title, children }: { title?: string; children?: ReactNode }) {
  usePageAnnouncements(title);
  return (
    <div className="flex min-h-dvh flex-col bg-canvas">
      <header className="on-dark flex h-navbar items-center bg-navbar px-4">
        <Link
          to="/"
          className="text-3xl font-light text-ink-inverse no-underline hover:text-ink-inverse hover:no-underline"
        >
          MantisBT
        </Link>
      </header>
      <main id="main" className="flex flex-1 items-start justify-center px-4 py-8 sm:items-center">
        <section
          aria-labelledby="page-title"
          className="w-full max-w-lg border border-border-widget bg-surface"
        >
          {title && (
            <h1
              id="page-title"
              tabIndex={-1}
              className="border-b border-border-widget bg-surface-raised px-4 py-2.5 text-2xl font-light text-primary-ink outline-none"
            >
              {title}
            </h1>
          )}
          <div className="p-4">{children ?? <Outlet />}</div>
        </section>
      </main>
    </div>
  );
}
